(function($) { $(document).ready(function() {
    initHoverAction();

    function initHoverAction() {
        if ($(".hover-image").length > 0) {
            $(".hover-image").on({
                mouseover:function(){
                    $(this).find('img').first().stop().animate({opacity:0},300);
                    $(this).find('img').last().stop().animate({opacity:1},300);
                }, mouseout:function(){
                    $(this).find('img').first().stop().animate({opacity:1},300);
                    $(this).find('img').last().stop().animate({opacity:0},300);
                }
            });
        }
    }

}); })( jQuery );